import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import { Base64Service } from 'src/app/core/base64.service';
import { StorageBrowserService } from 'src/app/core/storage/storage-browser.service';
import { UserService } from 'src/app/core/user.service';
import { FileItemService } from 'src/app/file/file-item.service';
import { EventItem, EventPathitems } from '../activity-log.model';
import { ActivityLogItemService } from '../activity-log-item.service';
import { Router } from '@angular/router';
import { UtilService } from '@material-library';
import { FileItem, LinkListItem } from 'src/app/shared/models';
import { IFile } from 'src/sync';

@Component({
  selector: 'app-activity-log-item',
  templateUrl: './activity-log-item.component.html',
  styleUrls: ['./activity-log-item.component.scss'],
})
export class ActivityLogItemComponent implements OnInit {
  @Input() public eventItem!: EventItem;
  @Input() public eventSharedata: any;

  public eventType!: string;
  public syncPid!: number;
  public shareName!: string;
  public stateref!: string;
  public stateTarget = '_blank';
  public stateParams!: any;
  public myTemplate: any = '';
  public userId!: number;
  public myShareId!: number;
  public isOverQuota!: boolean;

  public getEventActor!: string;
  public getIsFolder!: boolean;

  public popupIsOpen: boolean = false;
  public popupTitle: string = 'Event details';
  public popupSubTitle: string;
  public popupAltSubTitle: string;
  public popupEventId!: string;
  public fileLink: string;
  public fileLinkParams: any;
  public pathListLimit = 50;
  @ViewChild('dialoglinkcontent') dialoglinkcontent: TemplateRef<any>;
  public linkItem: LinkListItem | IFile;
  public openState: number;
  linkDialogPreventDoubleClick: boolean = false;
  constructor(
    private base64Service: Base64Service,
    private browserStorageService: StorageBrowserService,
    private userService: UserService,
    private fileItemService: FileItemService,
    private apiService: ApiService,
    public activityLogItemService: ActivityLogItemService,
    private router: Router,
    private utilService: UtilService,
    private viewContainerRef: ViewContainerRef,
  ) { }

  ngOnInit() {
    this.eventType = this.eventItem.eventtype;
    // console.log('eventItem',this.eventType, this.eventItem,'eventSharedata', this.eventSharedata);

    this.syncPid = 0;
    this.shareName = '';
    this.userId = this.userService.get('id');
    this.myShareId = this.userService.get('share_id');
    if (this.browserStorageService.storageType == 'memory') {
      this.stateTarget = '';
    }
    if (this.eventSharedata && this.eventItem.share_id && this.eventSharedata[this.eventItem.share_id]) {
      this.syncPid = this.eventItem.items.root_sync_id;
      this.shareName = this.eventItem.items.name;
    }
    if (this.eventType.indexOf('link-') > -1) {
      this.syncPid = this.eventItem.items.syncPid;
    }
    if (this.eventType == 'account-migrated') {
      if (this.eventItem.items.invited_by_email.indexOf('_') == 16) {
        this.eventItem.items.invited_by_email = this.eventItem.items.invited_by_email.slice(17);
      }
    }
    if (this.eventType == 'path-move' || this.eventType == 'path-move-share') {
      this.eventItem.items.pathitems = this.eventItem.items.pathitems.filter((pathitem: any) => {
        return pathitem.active > 0;
      });
    }
    this.stateref = `${this.getFileListContext()}`;
    const highlightParam = this.eventItem.items.sync_id;
    this.stateParams = { highlight: highlightParam };

    this.setOverQuota();
    this.setEventActor();
    this.setFileLink();
  }

  private getFileListContext(): string {
    return this.isVault() ? '/vault' : '/files';
  }

  private isVault(): boolean {
    return this.eventItem.items && this.eventItem.items.invault == 1;
  }

  private setOverQuota() {
    this.isOverQuota = this.eventItem.items && (this.eventItem.items.hasfailedfiles & 4) == 4;
  }

  private setEventActor() {
    if (['path-add-share', 'path-add', 'path-deleted-share', 'path-deleted', 'path-edited-share', 'path-edited',
      'path-move-share', 'path-move', 'path-purge-share', 'path-purge', 'path-rename-share', 'path-rename', 'path-restore-share',
      'path-restore'].includes(this.eventType)) {
      this.getEventActor = this.eventItem.items.event_user_id == this.userId ? 'You' : this.base64Service.decode(this.eventItem.items.event_display_name);
      this.setIsFolder();
    }
  }

  private setIsFolder() {
    this.getIsFolder = (this.eventItem.items && this.eventItem.items.pathitems && this.eventItem.items.pathitems.length && this.eventItem.items.pathitems[0].blob_id == 0);
  }

  public async getLinkData(): Promise<IFile> {
    const pathget = await this.apiService.execute('pathget', { sync_id: this.eventItem.items.sync_id || this.eventItem.items.sync_pid });
    const item = await this.fileItemService.format(pathget);
    console.log('openLinkDialog', this.eventItem, item);
    return item
  }

  public openEventDetails() {
    if (this.fileLink) {
      this.router.navigate([this.fileLink], { queryParams: this.fileLinkParams });
    } else {
      this.popupEventId = this.eventItem._id;
      this.popupIsOpen = true;
    }
  }

  public setFileLink() {
    const pathItems = this.eventItem.items.pathitems;
    this.fileLink = '';
    this.fileLinkParams = {};
    if (pathItems?.length == 1) {
      this.fileLink = this.activityLogItemService.itemLink(pathItems[0]);
      this.fileLinkParams = this.activityLogItemService.getStateParams(pathItems[0])
    }
  }

  onClose = () => {
    this.popupIsOpen = false;

  };
  onCancel = () => {
    console.log('onClose');

  }

  public onActivityLogLoad = (pathItems: EventPathitems[]) => {
    this.popupSubTitle = pathItems.length + " items";
    if (pathItems.length > 0) {
      const firstItem = pathItems[0];
      this.popupAltSubTitle = this.utilService.formatDate(new Date(firstItem.servtime), 'MMM d, y h:mm a');
    } else {
      this.popupAltSubTitle = '';
    }
  }

  openLinkDialog = async () => {
    if (this.linkDialogPreventDoubleClick) return;
    this.linkDialogPreventDoubleClick = true;
    const rowData: IFile = await this.getLinkData();
    this.openState = 0;
    this.linkItem = rowData;
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.dialoglinkcontent);
    this.linkDialogPreventDoubleClick = false;
  }
}
